const apiUrl = {
  REGISTRATION: "/smart-engage/post/register",
  LIST_SUB_CAMPAIGN: "/smart-engage/get/list-subcampaign",
  SUB_CAMPAIGN_DETAIL: "/smart-engage/get/subcampaign/",
  COUPON_DETAIL: "/smart-engage/get/coupon-detail/",
  SUB_CAMPAIGN_COUPON_DETAIL: "/smart-engage/get/subcampaign-coupon-detail/",
  VERIFY_REGISTRATION: "/smart-engage/get/register/verify-invitation/",
  SUB_CAMPAIGN_REGISTER: "/smart-engage/get/subcampaign_register_page/",
  SUBCAMPAIGN_BY_CHANNEL: "/smart-engage/get/subcampaign-info-by-channel/",
  CUSTOMER_SUBCAMPAIGN_STATUS: "/smart-engage/get/customer_subcampaign_status/",
  REDEEM_COUPON: "post/redeem-coupon/v-front",
  REDEEM_COUPON_V2: "post/redeem-coupon/se/v1",
  REDEEM_STATUS: "post/pull-coupon-redemption-status",
  ANONYMOUS_REDEEM_COUPON: "post/redeem-coupon/anonymous",
  SEND_COUPON: "/smart-engage/get/engage-v2/",
  ENGAGE_ACTION: "/smart-engage/post/engage-action",
  GET_URL: "/smart-engage/get/verify/",
  ENGAGE_DAGC: "/smart-engage/post/engage-dagc",
  PULL_DAGC_QUALIFICATION_STATUS: "/smart-engage/post/pull-qualification-and-redirect-to-download",
  GET_LINE_ACCESS_TOKEN: "/smart-engage/get/line-access-token",
  OTP_GET_COUNTRIES_AND_BLOCKED_PHONE_PREFIX: "/smart-engage/get/countries-with-blocked-phone-number-prefixes",
  OTP_SEND_PHONE_NUMBER: "/smart-engage/post/sms-verify-line-user",
  OTP_SEND_OTP: "/smart-engage/post/verify-otp",
  VALIDATE_OU_PAYMENT: "/get/validate-ou-payment/",
  VALIDATE_ENGAGE_SESSION: "/smart-engage/get/validate-engage-session/",
  CREATE_ENGAGE_GET_CREDIT: "/smart-engage/post/create-engage-get-credit-session",
  VALIDATE_ENGAGE_FIRST: "/smart-engage/post/validate-engage-get-credit",
  GET_USER_INFO: "/smart-engage/get/user-info/",
  ISSUE_COUPON: "/smart-engage/post/issue-coupon",
  REDEEM_SELF_SERVICE_COUPON: "/smart-engage/post/redeem-self-service-coupon",
  VALIDATE_CAMPAIGN_ENGAGED_LIMIT: "/smart-engage/get/validate-campaign-engaged-limit/",
  SEND_RECEIPT_EMAIL: "/send-receipt-email",
  LOYALTY_SUBMIT: "/smart-engage/post/loyalty-submit",
  MULTI_COUPONS: "/smart-engage/get/multi-coupons/",
  GET_LIST_PAGE: "/smart-engage/get/se-list-page/:id/",
  UPDATE_PAYPAY_CONSENT: "/smart-engage/put/paypay-consent",
  CREATE_PAY_GET_COUPON: "/smart-engage/post/create-pay-get-coupon",
};

export default apiUrl;
